import { CellRenderType } from '/@/modules/core/table/constants/TableConstant';
import BaseCellRender from './BaseCellRender';

class BooleanCellRender extends BaseCellRender {
  constructor() {
    super(CellRenderType.BOOLEAN);
  }
}

export default BooleanCellRender;
